import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';

import Button from '../Button';
import DropSection from '../DropSection';
import ImagePreview from '../ImagePreview';
import { getSmDropZone, getSmPreviewrContainer } from '../../../constants/FloorPlan';

import styles from './styles.scss';


class FloorPlanUpload extends React.Component {
  static get propTypes() {
    return {
      files: PropTypes.array,
      onDrop: PropTypes.func,
      onClear: PropTypes.func,
      urls: PropTypes.array,
      showIcon: PropTypes.bool,
      isTestImages: PropTypes.bool,
      maxSize: PropTypes.number
    };
  }

  render() {
    const {
      onDrop,
      isTestImages,
      onClear,
      urls,
      showIcon,
      maxSize,
      files,
    } = this.props;
    const smDropZone = getSmDropZone(isTestImages);
    const smPreviewrContainer = getSmPreviewrContainer(isTestImages);

    return (
      <Container className='px-0'>
        <Row className='text-left'>
          <Col xs={12} sm={smDropZone} className='mb-3'>
            <DropSection
              accept='image/*' // TODO: Swith off while waiting to answer application/pdf'
              onDrop={onDrop}
              multiple={isTestImages}
              maxSize={maxSize}
            />
          </Col>
          <Col xs={12} sm={smPreviewrContainer} className='text-center mb-3'>
            <Row className={`d-table w-100 ${styles.previewContainer}`}>
              {files.map((file, index) => (
                <Col className={`d-table-cell ${styles.imageWrap}`} key={index}>
                  <Choose>
                    <When condition={file && file.type === 'application/pdf'}>
                      <div>{file.name}</div>
                    </When>
                    <When condition={file && file.preview}>
                      <ImagePreview src={file.preview} />
                    </When>
                    <When condition={urls && urls[index]}>
                      <ImagePreview src={urls[index]} />
                    </When>
                    <Otherwise>
                      <ImagePreview />
                    </Otherwise>
                  </Choose>
                  <Col>
                    <Button
                      disabled={!file && !urls[index]}
                      className={`mt-3 ${styles.clearButton}`}
                      kind='danger'
                      onClick={() => onClear(index)}
                    >
                      {showIcon && <i className='fa fa-eraser mr-1' />} Remove file
                    </Button>
                  </Col>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default FloorPlanUpload;


// WEBPACK FOOTER //
// src/components/shared/FloorPlanUpload/index.jsx